/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import axios from 'axios'
import {Toast, Dialog} from 'react-weui'
import {Page, WKError} from '../../components'
import { WKVisible } from '../../components/wk'
import '../../css/page/LecturerInvitePage.css'
import errorImg from '../../images/no-source.png'
import logoShareImg from '../../images/icon-logo-share.png'
import {isLZWKAPP} from '../../utils'

class LecturerInviteCard extends React.Component {

    constructor() {
        super();
        this.state = {
            iconRotate: false,
            loading: false,
            dialogShow: false,
            dialogButton: [
                {
                    label: '好的',
                    onClick: this.handleEnterClassroom.bind(this)
                }
            ]
        };
        this.handleRefresh = this.handleRefresh.bind(this);
        document.title = '嘉宾邀请函'
        this.isApp = isLZWKAPP()
        this.handleCardTouch = this.handleCardTouch.bind(this);
    }

    handleCardTouch() {
        if(this.isApp){
            const title = "课程嘉宾邀请"
            const description = "课程嘉宾邀请卡"
            const link = window.location.href
            const icon = "https://static-1253442168.file.myqcloud.com/xupload/20191206_WechatIMG127.jpeg"
            if(window.systemType === 'android'){
                WKApp.shareUrl(title, description, link, icon);
            } else {
                const dic = {
                    "function": "shareUrl",
                    "json": {
                        "share_description": title,
                        "share_icon": icon,
                        "share_title": description,
                        "share_url": link
                    }
                }
                window.webkit.messageHandlers.WKApp.postMessage(dic)
            }
        }
    }

    componentDidMount() {

        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: '课程嘉宾邀请',
                desc: '课程嘉宾邀请卡',
                imgUrl: logoShareImg,
                type: 'link',
                link: window.location.href
            }
        });

        let target_id = this.props.routeParams.target_id;
        axios.get(`/api/lecture/${target_id}/lecturer/qrcode_invite`)
            .then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'LECTURER_INVITE_CARD_INIT',
                        payload: res.data.data
                    });
                    if (!res.data.data.is_manager && res.data.data.is_lecturer){
                        this.setState({
                            dialogShow: true
                        })
                    }
                } else {
                    this.page.showAlert(res.data.msg)
                }
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '网络连接出问题了。',
                        img: errorImg,
                        href: '/?st=lecturer_invite_404',
                        btn: '去首页看看'
                    }
                });
            }else if (error.response && error.response.status === 403){
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '你没有查看此内容的权限',
                        img: errorImg,
                        href: '/?st=lecturer_invite_403',
                        btn: '去首页看看'
                    }
                });
            }
        });
    }

    handleRefresh() {
        let target_id = this.props.routeParams.target_id;
        this.setState({
            iconRotate: true,
            loading: true,
        });
        axios.get(`/api/lecture/${target_id}/lecturer/qrcode_invite?refresh=1`)
            .then(res => {
                console.log(res)
                if (res.data.code === 0) {
                    this.setState({
                        loading: false,
                    });
                    this.props.dispatch({
                        type: 'LECTURER_INVITE_CARD_INIT',
                        payload: res.data.data
                    })
                } else {
                    this.page.showAlert(res.data.msg)
                }
            })
        /*this.toastTimer = setTimeout(() => {
            this.setState({
                iconRotate: false,
            });
        }, 2000);*/
    }

    handleEnterClassroom() {
        this.setState({
            dialogShow: false
        });
        let target_id = this.props.routeParams.target_id;
        browserHistory.replace(`/lecture2/${target_id}`)
        window.location.reload()
    }

    componentWillUnmount() {
        this.toastTimer && clearTimeout(this.toastTimer)
    }

    render() {
        /*const {iconRotate} = this.state;*/
        const {inviteCard, error} = this.props;

        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }


        return (
            <Page parent={this}>
                <Dialog type="ios" title={'温馨提示'} buttons={this.state.dialogButton} show={this.state.dialogShow}>
                    你已是本课程的嘉宾，<br/>
                    现已可以以讲师身份进入课堂
                </Dialog>
                <Toast icon="loading" show={this.state.loading}/>
                <div className="lecturer-invite-card">
                    {inviteCard &&
                    <div>
                        <div className="card-area" onClick={this.handleCardTouch} >
                            <img src={inviteCard.share_card_url} alt=""/>
                        </div>
                        {inviteCard.is_manager &&
                        <div className="info-area">
                            <WKVisible create={isLZWKAPP()}>
                                <div className="app-share-btn" onClick={this.handleCardTouch}>点击此处分享给嘉宾</div>
                            </WKVisible>
                            <p>{isLZWKAPP() ? '1.分享给好友，好友点击链接后即可成为嘉宾' : '1.长按上图，分享给好友即可邀请用户成为嘉宾'}</p>
                            <p>2.邀请函会于{inviteCard.expire_time}过期</p>
                        </div>
                        }
                    </div>
                    }
                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    inviteCard: state.lecturerInvite.inviteCard,
    error: state.error,
}))(LecturerInviteCard)



// WEBPACK FOOTER //
// ./src/pages/lecutrerInvite/LecturerInviteCard.js